"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginRole = void 0;
var LoginRole;
(function (LoginRole) {
    LoginRole["APPOINTMENT_COORDINATOR"] = "appointment_coordinator";
    LoginRole["DEALERSHIP_ADMIN"] = "dealership_admin";
    LoginRole["DEALERSHIP_CUSTOMER"] = "dealership_customer";
    LoginRole["DEALERSHIP_GUEST"] = "dealership_guest";
    LoginRole["SERVICE_MANAGER"] = "service_manager";
    LoginRole["SERVICE_WRITER"] = "service_writer";
    LoginRole["SYSTEM_ADMIN"] = "system_admin";
})(LoginRole = exports.LoginRole || (exports.LoginRole = {}));
//# sourceMappingURL=LoginRole.js.map